import Radio, { Button, Group } from 'antd/lib/radio';
import 'antd/lib/radio/style/index.css';

export { Button, Group };
export default Radio;
